import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CreditCard, Loader2, Download } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function DriverCardWaitlistAdmin() {
  const [data, setData] = useState(null);
  const [exporting, setExporting] = useState(false);
  const exportCsv = async () => {
    setExporting(true);
    try {
      const res = await api.get("/admin/driver-card/waitlist.csv", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = `driver-card-waitlist-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
      URL.revokeObjectURL(url); toast.success("Waitlist CSV downloaded");
    } catch { toast.error("Export failed"); } finally { setExporting(false); }
  };
  useEffect(() => { api.get("/admin/driver-card/waitlist").then((r) => setData(r.data)).catch(() => setData({ count: 0, items: [] })); }, []);
  const fmt = (d) => d ? new Date(d).toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" }) : "—";
  return (
    <section className="p-5 rounded-2xl bg-[#131722] border border-slate-800" data-testid="driver-card-waitlist-admin">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-lg font-bold flex items-center gap-2"><CreditCard className="w-4 h-4 text-cyan-400" />Driver Card waitlist</h3>
        {data && <div className="flex items-center gap-3"><span className="font-mono text-xs text-slate-400" data-testid="driver-card-waitlist-count">{data.count} signed up · +{data.spots_per_referral} spots per referral</span>
          <Button size="sm" variant="outline" onClick={exportCsv} disabled={exporting || !data.count} data-testid="driver-card-waitlist-export" className="bg-transparent border-slate-700 h-8 text-xs">{exporting ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Download className="w-3.5 h-3.5 mr-1.5" />Export CSV</>}</Button></div>}
      </div>
      {!data ? <Loader2 className="w-5 h-5 animate-spin text-slate-500" /> : data.items.length === 0 ? <p className="text-sm text-slate-500">Nobody has joined yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-[11px] font-mono uppercase tracking-widest text-slate-500 text-left border-b border-slate-800">
              <th className="py-2 pr-3">Rank</th><th className="py-2 pr-3">Name</th><th className="py-2 pr-3">Email</th><th className="py-2 pr-3">Signed up</th><th className="py-2 pr-3">Referrals</th><th className="py-2">Boost</th>
            </tr></thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.entry_id} className="border-b border-slate-800/60 text-slate-200" data-testid={`waitlist-row-${r.entry_id}`}>
                  <td className="py-2 pr-3 font-mono text-cyan-300">#{r.rank}{r.rank !== r.position && <span className="text-slate-600 ml-1">(joined #{r.position})</span>}</td>
                  <td className="py-2 pr-3">{r.name || "—"}</td>
                  <td className="py-2 pr-3 text-slate-400">{r.email}</td>
                  <td className="py-2 pr-3 text-slate-400">{fmt(r.created_at)}</td>
                  <td className="py-2 pr-3 font-mono">{r.referrals}</td>
                  <td className="py-2 font-mono text-emerald-300">{r.boost ? `↑${r.boost}` : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
